import {VCard} from "../../../types/ParsedVCardTypes";
import {deepClone} from "../deepClone.ts";

const cleanVCardMetadata = (data: VCard): VCard => {
    const cleanedData = deepClone(data);

    for (let prop in cleanedData) {
        if (cleanedData[prop]) {
            // remove the 'charset' property if it exists
            if ('charset' in cleanedData[prop]) {
                delete cleanedData[prop].charset;
            }

            // same for case insensitive 'Charset'
            if ('Charset' in cleanedData[prop]) {
                delete cleanedData[prop].Charset;
            }

            // same for uppercase 'CHARSET'
            if ('CHARSET' in cleanedData[prop]) {
                delete cleanedData[prop].CHARSET;
            }
        }
    }

    return cleanedData;
}

export const removeCharsetFromVCards = (vCards: VCard[]): VCard[] => {
    return vCards.map(vCard => cleanVCardMetadata(vCard));
}

// example usage
// const cleanedVCards = removeCharsetFromVCards(vCards);